module.exports = __webpack_public_path__ + "assets/img/text-to-speech.909278a2.png";